class BaseValidator {
    constructor(
        private errors: string[] = [],
        private subValidators: BaseValidator[] = [],
        protected dependencies: object = {},
    ) {}

    public setDependencies(dependencies: object): void {
        this.dependencies = {...dependencies};
    }

    public addSubValidators(validators: BaseValidator[]): void {
        this.subValidators = [...this.subValidators, ...validators];
    }

    public validate(): boolean {
        this.runValidation();

        this.runValidationOfSubValidators();

        return !this.hasErrors();
    }

    protected runValidation(): void {}

    private runValidationOfSubValidators(): void {
        this.subValidators.map((validator) => {
            if (validator.validate()) {
                return;
            }
            validator.getErrors().map((error) => this.addError(error));
        });
    }

    public addError(error: string): void {
        this.errors.push(error);
    }

    public getErrors(): string[] {
        return [...this.errors];
    }

    public getFirstError(): string {
        if (this.hasErrors()) {
            return this.errors[0];
        }
        throw new Error('Errors are absent.');
    }

    public hasErrors(): boolean {
        return !isEmpty(this.errors);
    }
}

export default BaseValidator;
